<template>
  <div class="h-[500px]">
    <!-- Dashboard -->
    <StepTwoDashboard
      :orderCount="List.length"
      :totalAmount="totalAmount"
      :totalVehicles="totalRequimentVehicleCount"
    />
    <AddCustomerModal
      modal-name="add-customer-modal"
      @formSubmitted="handleCustomerFormSubmitted"
      :customerName="selected?.customer"
    />
    <div class="p-5 overflow-y-auto h-full xl:pb-1 pb-10">
      <div
        class="shadow h-96 overflow-x-scroll border border-gray-200 bg-white dark:bg-gray-900 rounded-xl"
      >
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
            <tr>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Sipariş
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Müşteri
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Miktar
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Rota
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Araç
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Tür
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Mesafe
              </th>
              <th class="px-3 py-2 text-left text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide">
                Tarih
              </th>
              <th class="px-3 py-2 text-center text-xs font-medium text-gray-500 dark:text-gray-400 tracking-wide w-20">
                
              </th>
            </tr>
          </thead>
          <tbody class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            <!-- Add new order row -->
            <NewOrderRow
              :loading="load"
              @add-order="handleAddOrder"
              @reset="handleResetForm"
              ref="newOrderRow"
            />
            
            <!-- Order list -->
            <OrderRow
              v-for="(item, index) in List"
              :key="index"
              :item="item"
              :index="index"
              @delete-order="deleteItem"
              @update-vehicle-type="updateVehicleType"
            />
            
            <!-- Loading handled by NewOrderRow component now -->
            <!-- <tableLoader :load="load" colspan="10" /> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
//Npm
import moment from "moment";

//Global Components
import tableLoader from "@/components/general/table-loader.vue";

// Local Components  
import StepTwoDashboard from "./stepTwo/StepTwoDashboard.vue";
import NewOrderRow from "./stepTwo/NewOrderRow.vue";
import OrderRow from "./stepTwo/OrderRow.vue";
import AddCustomerModal from "../../../../../control-panel/customers/components/add.modal.vue";
//Networking
import axios from "axios";
import { bulkShipPlanning } from "@/networking/urlmanager";
import { routeEngine } from "@/networking/routeEngine";

//Utils
import calculatorModel from "@/utils/vehecleCountRecomendation.js";
export default {
  name: "steptwoPage",
  props: [
    "shipId",
    "isAdd",
    "orderCount",
    "dates",
    "isLaterAddOrder",
    "minVehicleCount",
  ],
  components: {
    tableLoader,
    StepTwoDashboard,
    NewOrderRow,
    OrderRow,
    AddCustomerModal
  },
  data() {
    return {
      // routes: [],
      load: false,
      orderId: "",
      selected: {
        amount: "",
        deliveryDate: "",
        targetAdress: "",
        customer: "",
        kilometer: "",
        recomendedCount: "",
        customerId:"",
      },
      totalRequimentVehicleCount: 0,
      totalAmount: 0,
      List: [],
      activeRoute: 0,
      routes: {},
    };
  },

  methods: {
    handleCustomerFormSubmitted(data) {
      this.selected.customerId=data.customerId;
      this.getRoute();
    },
    handleAddOrder(data) {
      this.orderId = data.orderId;
      this.selected = data.selected;
      if(data.selected.customerId==null || data.selected.customerId==undefined || data.selected.customerId==""){
        this.swalBox(
          "warning",
          "UYARI!",
         'Müşteri Kaydı Bulunmamaktadır.',
          false,
          "Tamam"
        ).then((result) => {
          if (result.isConfirmed) {
            this.$modal.show("add-customer-modal");
          }
          return;
        });
      }else{
        this.getRoute();
      }
      
    },
    handleResetForm() {
      this.resetItem();
    },
    updateVehicleType(data) {
      this.List[data.index].haveType = Number(data.value);
    },
    deleteItem(index) {
      this.swalBox(
        "warning",
        this.$t("general.warningTitle"),
        "SİPARİŞİ LİSTEDEN ÇIKARMAK İSTEDİĞİNİZE EMİN MİSİNİZ?",
        true,
        this.$t("general.confirmText")
      ).then((acc) => {
        if (acc.isConfirmed) {
          if (index > -1 && index < this.List.length) {
            const itemToRemove = this.List[index];
            
            // Toplam araç sayısı ve miktardan çıkar
            this.totalRequimentVehicleCount = Math.max(0, this.totalRequimentVehicleCount - (itemToRemove.recomendedCount || 0));
            this.totalAmount = Math.max(0, this.totalAmount - (Number(itemToRemove.amount) || 0));
            
            // Listeden çıkar
            this.List.splice(index, 1);
            
            this.swalBox(
              "success",
              this.$t("general.successTitle"),
              "Sipariş başarılı bir şekilde kaldırıldı...",
              false,
              this.$t("general.OkayTitle")
            );
          } else {
            this.swalBox(
              "warning",
              "HATA",
              "Sipariş kaldırılırken  bir hata oluştu lütfen tekrar deneyin...",
              false,
              this.$t("general.OkayTitle")
            );
          }
        }
      });
    },
    async calculateVehicleCount(totalMinute, deliveryDate, amount, orderDate) {
      const totalTonnage = amount;
      const loadPerVehicle = 26; // her bir aracın bir seferde taşıyabileceği yük miktar
      const maxDailyDrivingTime = 540;

      const { requiredVehicles, errorMessage } =
        await new calculatorModel().calculateRecomendedCount(
          orderDate,
          1,
          totalMinute,
          this.dates?.filling, //30, //this.fillingDate,
          this.dates?.delivery, //this.deliveryDate,
          deliveryDate,
          totalTonnage,
          loadPerVehicle,
          maxDailyDrivingTime,
          1 // normal calculate
        );

      if (errorMessage) {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          errorMessage,
          false,
          this.$t("general.OkayTitle")
        );
        return;
      }

      if (!Array.isArray(requiredVehicles)) {
        return requiredVehicles;
      }
    },
    getRoute() {
      if (this.orderId == "") {
        this.swalBox(
          "warning",
          "UYARI!",
          "LÜTFEN ÖNCE BİR SİPARİŞ SEÇİN...",
          false,
          this.$t("general.OkayTitle")
        );
        return;
      }
      const alreadyAdded = this.List.some(
        (item) => item.id === this.selected.id
      );
      if (alreadyAdded) {
        this.swalBox(
          "warning",
          "UYARI!",
          "Sipariş zaten listenize eklenmiş. Tekrar eklemek mümkün değil.",
          false,
          this.$t("general.OkayTitle")
        );
        return;
      }
      this.activeRoute = 0;
      this.load = true;
      axios
        .post(
          routeEngine.generate,
          {
            from: {
              lat: Number(this.selected.outpointLat),
              lng: Number(this.selected.outpointLng),
            },
            to: {
              lat: Number(this.selected.targetPointLat),
              lng: Number(this.selected.targetPointLng),
            },
            fuelRatio: 35,
            isPolyline: 1,
            shippedHazardousGoods: 1,
            vehicleTypeId: 5,
            routeType: "fast",
            isApi: 1,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.routeEngineToken,
            },
          }
        )
        .then((res) => {
          this.routes = res.data.data;
          // this.routes = res.data.data[0];
          this.addItem();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.load = false;
        });
    },
    async addItem() {
      const data = this.routes;
      const kilometer = data.kilometer;
      const time = data.totalMinutes;
      const orderDate = this.selected.orderDate;

      const recomendedCount = await this.calculateVehicleCount(
        time,
        moment(this.selected.deliveryDate).format("YYYY-MM-DD HH:mm"),
        Number(this.selected.amount),
        orderDate
      );

      this.totalRequimentVehicleCount += recomendedCount;
      this.totalAmount += Number(this.selected.amount);

      this.List.push({
        ...this.selected,
        haveType: 3,
        kilometer: kilometer,
        time: time,
        recomendedCount,
        isStart:1
      });

      this.resetItem();
    },

    resetItem() {
      this.orderId = "";
      this.selected = {
        amount: "",
        deliveryDate: "",
        targetAdress: "",
        customer: "",
        outpointAdress: "",
      };
      // Reset the NewOrderRow component form
      if (this.$refs.newOrderRow) {
        this.$refs.newOrderRow.resetForm();
      }
    },

    async controller() {
      return new Promise((resolve, reject) => {
        const totalCalculatedVehicles = this.List.reduce(
          (sum, order) => sum + order.recomendedCount,
          0
        );

        const additionalVehiclesNeeded = Math.max(
          this.minVehicleCount - totalCalculatedVehicles,
          0
        );

        if (additionalVehiclesNeeded > 0) {
          this.swalBox(
            "warning",
            this.$t("general.warningTitle"),
            "Araç sayısı otomatik olarak artırıldı: Operasyon için gereken minimum sayıya ulaşıldı.",
            false,
            this.$t("general.OkayTitle")
          )
            .then(() => {
              // Ek araçları siparişler arasında paylaştıralım
              this.distributeAdditionalVehicles(additionalVehiclesNeeded);
              resolve();
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        } else resolve();
      });
    },
    async save(callback) {
      if (this.List.length == 0) {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          "Lütfen ilk önce bir sipariş ekleyin!",
          false,
          this.$t("general.OkayTitle")
        );
        return callback(false);
      }

      await this.controller();
      axios
        .post(
          bulkShipPlanning.orderAdd,
          {
            orders: JSON.stringify(this.List),
            shipId: this.shipId,
            isAdd: this.isAdd && this.orderCount > 0 ? 1 : 0,
          },
          {
            headers: {
              Authorization: "Bareer " + this.$store.state.userData.token,
            },
          }
        )
        .then(() => {
          this.swalBox(
            "success",
            this.$t("general.successTitle"),
            "",
            false,
            this.$t("general.OkayTitle")
          );
          callback(true);
        })
        .catch((err) => {
          this.errorBox(err.response);
          callback(false);
        });
    },
    distributeAdditionalVehicles(additionalVehicles) {
      // Siparişleri miktarlarına göre sıralayalım (büyükten küçüğe)
      const sortedList = [...this.List].sort((a, b) => b.amount - a.amount);
      let remainingVehicles = additionalVehicles;
      let index = 0;
      while (remainingVehicles > 0 && index < sortedList.length) {
        sortedList[index].recomendedCount++;
        remainingVehicles--;
        index = (index + 1) % sortedList.length;
      }
      // Orijinal listeyi güncelleyelim
      this.List.forEach((order) => {
        const updatedOrder = sortedList.find((o) => o.id === order.id);
        order.recomendedCount = updatedOrder.recomendedCount;
      });
    },
  },
  watch: {
    List: {
      handler(val) {
        this.$emit("changeList", val);
      },
      deep: true,
    },
  },
  filters: {
    dateFilter(val) {
      return moment(val).format("LLLL");
    },
  },
};
</script>
